import { API } from "@/lib/api";

const SID_KEY = "belo_sid";
const FT_KEY = "belo_ft";
const SESSION_TTL = 30 * 60 * 1000; // 30 min rolling session

const SEARCH = ["google.", "bing.", "yahoo.", "duckduckgo.", "ecosia.", "baidu.", "yandex."];
const SOCIAL = ["facebook.", "fb.", "instagram.", "t.co", "twitter.", "x.com", "linkedin.", "youtube.", "youtu.be", "reddit.", "tiktok.", "pinterest.", "whatsapp"];

function uuid() {
  try {
    if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  } catch (e) { /* noop */ }
  return Date.now().toString(36) + Math.random().toString(36).slice(2);
}

function getSession() {
  try {
    const raw = JSON.parse(localStorage.getItem(SID_KEY) || "null");
    const now = Date.now();
    if (raw && raw.id && now - raw.ts < SESSION_TTL) {
      localStorage.setItem(SID_KEY, JSON.stringify({ id: raw.id, ts: now }));
      return raw.id;
    }
  } catch (e) { /* noop */ }
  const id = uuid();
  try { localStorage.setItem(SID_KEY, JSON.stringify({ id, ts: Date.now() })); } catch (e) { /* noop */ }
  return id;
}

function deviceType() {
  const ua = (navigator.userAgent || "").toLowerCase();
  if (/ipad|tablet/.test(ua)) return "Tablet";
  if (/mobi|iphone|android/.test(ua)) return "Mobile";
  return "Desktop";
}

function classify(ref, utmSource, utmMedium) {
  if (utmSource) {
    const med = (utmMedium || "").toLowerCase();
    if (["cpc", "ppc", "paid", "paidsearch"].includes(med)) return ["Paid Search", utmSource];
    if (med.includes("social")) return ["Social", utmSource];
    if (["email", "newsletter"].includes(med)) return ["Email", utmSource];
    return ["Campaign", utmSource];
  }
  if (!ref) return ["Direct", "direct"];
  let host = "";
  try { host = new URL(ref).hostname.toLowerCase(); } catch (e) { host = ""; }
  if (!host || host.includes("belorentals")) return ["Direct", "direct"];
  if (SEARCH.some((s) => host.includes(s))) return ["Organic Search", host];
  if (SOCIAL.some((s) => host.includes(s))) return ["Social", host];
  return ["Referral", host];
}

// First-touch acquisition channel — computed once per browser, then persisted.
function firstTouch() {
  try {
    const saved = JSON.parse(localStorage.getItem(FT_KEY) || "null");
    if (saved && saved.channel) return saved;
  } catch (e) { /* noop */ }
  const p = new URLSearchParams(window.location.search);
  const utm_source = p.get("utm_source") || "";
  const utm_medium = p.get("utm_medium") || "";
  const utm_campaign = p.get("utm_campaign") || "";
  const [channel, source] = classify(document.referrer || "", utm_source, utm_medium);
  const ft = { channel, source, utm_source, utm_medium, utm_campaign };
  try { localStorage.setItem(FT_KEY, JSON.stringify(ft)); } catch (e) { /* noop */ }
  return ft;
}

export function track(type, extra = {}) {
  try {
    const ft = firstTouch();
    const body = {
      session_id: getSession(),
      type,
      path: extra.path || window.location.pathname,
      title: document.title || "",
      referrer: extra.includeRef ? document.referrer || "" : "",
      utm_source: ft.utm_source,
      utm_medium: ft.utm_medium,
      utm_campaign: ft.utm_campaign,
      ft_channel: ft.channel,
      ft_source: ft.source,
      device: deviceType(),
      meta: extra.meta || {},
    };
    fetch(`${API}/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
      keepalive: true,
      credentials: "omit",
    }).catch(() => {});
  } catch (e) { /* analytics must never break the app */ }
}

export function trackPageview(path) {
  const firstPv = !sessionStorage.getItem("belo_landed");
  if (firstPv) {
    try { sessionStorage.setItem("belo_landed", "1"); } catch (e) { /* noop */ }
  }
  track("pageview", { path, includeRef: firstPv });
}
